import { Component, OnInit, OnDestroy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { SocialAuthService } from 'angularx-social-login';
import { ActivatedTaskFromComplianceService } from './services/activatedTaskFromCompliance.service';
import { AssessmentHistoryService } from './services/assessmenthistory.service';
import { AssessmentSetupService } from './services/assessmentsetup.service';
import { BISCommunicationService } from './services/BISCommunication.service';
import { BoardEvaluationService } from './services/boardEvaluation.service';
import { CompanyMasterService } from './services/companymaster.service';
import { CompanySetupService } from './services/companySetup.service';
import { FinancialDataService } from './services/financialData.service';
import { EmissionCalculationService } from './services/emission-calculation.service';
import { AccessibilityService } from './services/accessibility.service';


import { LoginService } from './services/login.service';
import { MeetingMasterService } from './services/meetingMaster.service';
import { UINotificationService } from './services/notificationUI.service';
import { OTPLoginService } from './services/otp-login.service';
import { RoadmapService } from './services/roadmap.service';
import { RocketChatService } from './services/rocketChat.service';
import { RoleMasterService } from './services/rolemaster.service';
import { SocketService } from './services/socket.service';
import { SuperAdminSetupService } from './services/superAdminSetup.service';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { SessionTimeoutWarningComponent } from './components/session-timeout-warning/session-timeout-warning.component';
import { SessionTimeoutService } from './services/session-timeout.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.html',
  providers: [
    AssessmentSetupService,
    AssessmentHistoryService,
    BISCommunicationService,
    CompanyMasterService,
    CompanySetupService,
    SuperAdminSetupService,
    MeetingMasterService,
    LoginService,
    RoleMasterService,
    RoadmapService,
    FinancialDataService,
    UINotificationService,
    RocketChatService,
    SocketService,
    ActivatedTaskFromComplianceService,
    BoardEvaluationService,
    OTPLoginService,
    EmissionCalculationService
  ],
})
export class AppComponent implements OnInit, OnDestroy {
  isLogin: any = true;
  private subscriptions: Subscription[] = [];
  private sessionWarningModalRef: NgbModalRef | null = null;
  private isSessionMonitoring = false;

  constructor(
    public authService: SocialAuthService,
    public router: Router,
    private a11yService: AccessibilityService,
    private sessionTimeoutService: SessionTimeoutService,
    private modalService: NgbModal
  ) {
    var isLoginFromAuth = localStorage.getItem('isAuthLogin');
    if (isLoginFromAuth == 'yes') {
      this.authService.authState.subscribe((resData) => {
        this.isLogin = resData != null;
      });
      setTimeout(() => {
        if (!this.isLogin) {
          localStorage.clear();
          this.router.navigate(['login']);
        }
      }, 1000 * 10);
    }
  }

  ngOnInit(): void {
    this.a11yService.setPageTitle('Digi Company');
    this.setupSessionTimeoutListeners();
    this.syncSessionMonitoring();
  }

  ngOnDestroy(): void {
    if (this.isSessionMonitoring) {
      this.sessionTimeoutService.stopSessionMonitoring();
    }
    this.closeSessionWarningModal();
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  private setupSessionTimeoutListeners(): void {
    this.subscriptions.push(
      this.sessionTimeoutService.warning$.subscribe(() => {
        this.openSessionWarningModal();
      })
    );

    this.subscriptions.push(
      this.sessionTimeoutService.activityResumed$.subscribe(() => {
        this.closeSessionWarningModal();
      })
    );

    this.subscriptions.push(
      this.router.events
        .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
        .subscribe(() => {
          this.syncSessionMonitoring();
        })
    );
  }

  private syncSessionMonitoring(): void {
    if (this.sessionTimeoutService.isLoginOrPublicPage()) {
      this.closeSessionWarningModal();
      if (this.isSessionMonitoring) {
        this.sessionTimeoutService.stopSessionMonitoring();
        this.isSessionMonitoring = false;
      }
      return;
    }

    const token = localStorage.getItem('token');
    const shouldMonitor = !!token;

    if (shouldMonitor && !this.isSessionMonitoring) {
      this.sessionTimeoutService.startSessionMonitoring();
      this.isSessionMonitoring = true;
    } else if (!shouldMonitor && this.isSessionMonitoring) {
      this.sessionTimeoutService.stopSessionMonitoring();
      this.closeSessionWarningModal();
      this.isSessionMonitoring = false;
    }
  }

  private openSessionWarningModal(): void {
    if (this.sessionWarningModalRef || this.sessionTimeoutService.isLoginOrPublicPage()) {
      return;
    }

    this.sessionWarningModalRef = this.modalService.open(SessionTimeoutWarningComponent, {
      backdrop: 'static',
      keyboard: false,
      centered: true,
      windowClass: 'session-timeout-modal',
    });

    this.sessionWarningModalRef.result.then(
      () => {
        this.sessionWarningModalRef = null;
      },
      () => {
        this.sessionWarningModalRef = null;
      }
    );
  }

  private closeSessionWarningModal(): void {
    if (this.sessionWarningModalRef) {
      this.sessionWarningModalRef.dismiss('activity-resumed');
      this.sessionWarningModalRef = null;
    }
  }
}
